module.exports = __webpack_public_path__ + "img/xbcrafted-7cc4d9a8-dafc-4017-48a3-08d95b7e528f.png";